var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.127,
    height: 26.126,
    viewBox: "0 0 26.127 26.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_082-spotify",
    "data-name": "082-spotify",
    d: "M13.063,26.126A13.063,13.063,0,1,0,0,13.063,13.068,13.068,0,0,0,13.063,26.126Zm5.3-6.906h0c-.879,0-3.653-3.079-11.452-1.481a3.363,3.363,0,0,1-.627.137.865.865,0,0,1-.115-1.718c4.314-.953,8.723-.869,12.483,1.38a.877.877,0,0,1-.288,1.68Zm1.418-3.454c-.123-.033-.087.075-.65-.221A17.07,17.07,0,0,0,6.568,14a2.164,2.164,0,0,1-.627.137,1.071,1.071,0,0,1-.2-2.112A19.083,19.083,0,0,1,20.211,13.7a1.1,1.1,0,0,1,.6,1.037A1.021,1.021,0,0,1,19.785,15.766ZM4.951,7.618c4.924-1.441,12.375-.986,17.008,1.718a1.281,1.281,0,0,1-.542,2.417h0a1.213,1.213,0,0,1-.68-.206C16.988,9.308,10.281,8.771,5.942,9.982a2.535,2.535,0,0,1-.68.136A1.216,1.216,0,0,1,4.034,8.875a1.244,1.244,0,0,1,.917-1.257Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.86debc3d8fc2096664bd8b78a7a93c92.svg";
export { ForwardRef as ReactComponent };